import { supabase } from '@fd/supabase/index';
import { ENVIRONMENTS } from '../environment';
import { determineEnv } from './determineEnv';

export let p2pToken = (await supabase.from('user_account').select().single()).data
  ?.p2p_token;

const fetchP2PToken = async () => {
  p2pToken = (await supabase.from('user_account').select().single()).data?.p2p_token;
  return p2pToken;
};

type RequestMethod = 'POST' | 'GET' | 'DELETE';

export const httpApi = async (
  uri = '',
  params: object | undefined,
  method: RequestMethod = 'POST'
) => {
  if (!p2pToken) await fetchP2PToken();
  const headers: HeadersInit = {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: `Bearer ${p2pToken}`,
  };
  return await basicHttpApi(uri, params, headers, method);
};

export const basicHttpApi = async (
  uri = '',
  params: object | undefined,
  headers: HeadersInit,
  method: RequestMethod
) => {
  if (!uri) {
    throw new Error('!uri');
  }

  const resp = await fetch(
    `${ENVIRONMENTS[determineEnv()].proxyRouterUrl}${uri}`,
    {
      method,
      headers,
      body: params ? JSON.stringify(params) : undefined,
    }
  );
  if (resp.status === 204) return undefined;
  if (resp.status >= 400) {
    let message;
    console.error(resp.headers);
    const respBody = await resp.text();
    console.error(respBody);
    message = respBody;
    try {
      message = JSON.parse(respBody).message;
    } catch {
      // no JSON in response, return text
    }
    console.error({statusText: resp.statusText, headers: resp.headers, message: message});
    return {
      ok: 0,
      message: message,
      httpStatus: resp.status,
    };
  }
  const result =
    resp.headers.get('Content-Length') !== '0' ? await resp.json() : {};
  return result;
};
